import React from 'react'
import Dialog from 'material-ui/Dialog'

export default (props) => <Dialog  modal={true} {...props} />
